import React from 'react'
import { HelpCircle } from 'lucide-react'
import { Badge, Button, Modal } from '@/shared/ui'

export default function RewardsHowItWorksModal() {
  const [open, setOpen] = React.useState(false)

  return (
    <>
      <Button type="button" variant="outline" className="gap-2" onClick={() => setOpen(true)}>
        <HelpCircle className="h-4 w-4" />
        Como funciona
      </Button>

      <Modal open={open} onOpenChange={setOpen} className="max-w-xl">
        <div className="flex items-start justify-between gap-4">
          <div className="min-w-0">
            <div className="flex flex-wrap items-center gap-2">
              <Badge variant="soft" color="primary">
                Rewards
              </Badge>
              <Badge variant="soft" color="info">
                BingX
              </Badge>
            </div>

            <h2 className="mt-2 text-lg font-semibold">Como funciona o desconto</h2>
            <p className="mt-1 text-sm text-foreground/70">
              Você vincula sua conta na BingX ao programa do Cripto Alert, gera volume de negociação e recebe desconto progressivo na sua próxima
              fatura do ciclo.
            </p>
          </div>

          <Button type="button" variant="ghost" onClick={() => setOpen(false)}>
            Fechar
          </Button>
        </div>

        <div className="mt-4 space-y-2 text-sm text-foreground/80">
          <div className="rounded-md bg-muted/30 p-3">
            - O Rewards é calculado por <span className="font-medium text-foreground">ciclo</span> e não acumula para o próximo.
          </div>
          <div className="rounded-md bg-muted/30 p-3">
            - O desconto é aplicado na <span className="font-medium text-foreground">próxima fatura</span> (sem cashback/crédito).
          </div>
          <div className="rounded-md bg-muted/30 p-3">
            - O cálculo usa <span className="font-medium text-foreground">dados confirmados pela corretora</span>.
          </div>
        </div>
      </Modal>
    </>
  )
}
